import { AutoMap } from "@automapper/classes";
import { UserDTO } from "../services/dto/user.dto";
import { mapper } from "../tools/mapping/mapper";
import { Competence } from "./competence";
import { PlanningConfiguration } from "./planning-configuration";

export class User {

    @AutoMap()
    Email!: string;
    @AutoMap()
    Phone!: string;
    @AutoMap()
    FirstName!: string;
    @AutoMap()
    LastName!: string;
    @AutoMap()
    Puid!: string;
    @AutoMap()
    PlanningConfiguration: PlanningConfiguration = new PlanningConfiguration();
    @AutoMap(() => [Competence])
    CompetenceList: Competence[] = [];

    static mapFromJSON(json: any) {
        let u = new User();
        u = mapper.map(json, UserDTO, User);
        return u;
    }
}
